// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"e9eafe93","190":"d649b493","257":"664b8c6a","453":"4b8b135e","494":"488894d2","729":"db5a7e24"}[chunkId] + ".chunk.js";
};